import axios from "axios";
import { apiURL } from './api.js';

// Function to get all public reviews (4+ stars, newest first)
export const getReviews = async () => {
    try {
        const response = await axios.get(`${apiURL}/reviews`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status !== 200) {
            throw new Error('Failed to fetch reviews');
        }
        return response.data;
    } catch (error) {
        console.error('Error fetching reviews:', error);
        throw error;
    }
};

// Function to submit a new review
export const submitReview = async (data) => {
    try {
        const response = await axios.post(`${apiURL}/reviews`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status !== 201 && response.status !== 200) {
            throw new Error('Failed to submit review');
        }
        return response.data;
    } catch (error) {
        console.error('Error submitting review:', error);
        throw error;
    }
};
